import { SelectComponentsConfig } from 'react-select';

import { NULL_OP } from '../../../../constants';
import { Control } from '../overrideParts/Control';
import { CountryGroup, CountryOption } from '../types/CountryOption';

export const PHONE_REACT_SELECT_COMPONENTS_OVERRIDES: SelectComponentsConfig<
  CountryOption,
  false,
  CountryGroup
> = {
  Control,
  ValueContainer: NULL_OP,
};
